export const tableHeader = [
  { id: "entity_name", label: "Nome",  type: "name-description", nameKey: 'entity_name', descriptionKey: 'entity_description', sortable: true },
  { id: "entity_type", label: "Tipo", type: "type-entity" , sortable: true },
  { id: "progresso", label: "Progresso", type: "progress", sortable: true },
];
